import { PlatformUtils } from '@wix/thunderbolt-symbols'
import { getServiceAvailability } from './service-availability/service-availability'
import { getCheckoutOptions } from './checkout-options/checkout-options'
import { checkoutBooking } from './checkout-booking/checkout-booking'
import { namespace, BookingsWixCodeSdkWixCodeApi } from '..'
import { BOOKINGS_APP_DEF_ID } from './common/config'
import { prepareBookingsApi } from './common/api'

/**
 * This is SDK Factory.
 * Expose your Corvid API
 */
export function BookingsSdkFactory(
	_: any,
	__: any,
	{ sessionService }: PlatformUtils
): { [namespace]: BookingsWixCodeSdkWixCodeApi } {
	const getRequestHeaders = () => ({
		Authorization: sessionService.getInstance(BOOKINGS_APP_DEF_ID),
	})
	prepareBookingsApi(getRequestHeaders)

	return {
		[namespace]: {
			getServiceAvailability,
			getCheckoutOptions,
			checkoutBooking,
		},
	}
}
